module.exports = __webpack_public_path__ + "img/lukoil-logo.d9731b55.svg";